import { render, staticRenderFns } from "./capabilities.vue?vue&type=template&id=a3b7f9a4&scoped=true&"
import script from "./capabilities.vue?vue&type=script&lang=js&"
export * from "./capabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b7f9a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3b7f9a4')) {
      api.createRecord('a3b7f9a4', component.options)
    } else {
      api.reload('a3b7f9a4', component.options)
    }
    module.hot.accept("./capabilities.vue?vue&type=template&id=a3b7f9a4&scoped=true&", function () {
      api.rerender('a3b7f9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/capabilities.vue"
export default component.exports